(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Home.ManageUsers",
            {
                url: "/ManageUsers",
                component: "manageUsers",
                resolve: {
                    onBefore: ["permissionService", "$state",
                        function (permissionService, $state) {
                            if (!permissionService.hasAllPermissions([{ AccessObject: "UsersAll", ActionType: "View" }])
                                && !permissionService.hasAllPermissions([{ AccessObject: "UsersOwn", ActionType: "View" }]))
                                $state.go("Home.Dashboard");
                        }],
                    users: ["permissionService", "userApi", "transactionGroupApi", function (permissionService,
                        userApi, transactionGroupApi) {
                        if (permissionService.hasAllPermissions([{ AccessObject: "UsersAll", ActionType: "View" }])) {
                            return userApi.getAllUsers();
                        } else {
                            return userApi.getUserTransactionGroup().then(function (group) {
                                return transactionGroupApi.getTransactionGroupUsers(group.Id);
                            });
                        }
                    }],
                    user: ["userApi", function (userApi) {
                        return userApi.getCurrentTransactionGroupUserMember();
                    }],
                    userRegistrations: ["permissionService", "userApi", "userRegistrationApi", function (permissionService,
                        userApi, userRegistrationApi) {
                        if (permissionService.hasAllPermissions([{ AccessObject: "UsersAll", ActionType: "View" }])) {
                            return userRegistrationApi.getAllIncompleteUserRegistrations();
                        } else {
                            return userApi.getUserTransactionGroup().then(function (group) {
                                return userRegistrationApi.getAllIncompleteUserRegistrationsForTransactionGroup(group.Id);
                            });
                        }
                    }],
                    transactionGroups: ["permissionService", "transactionGroupApi", "userApi", function (permissionService, transactionGroupApi, userApi) {
                        if (permissionService.hasAllPermissions([{ AccessObject: "UsersAll", ActionType: "View" }])) {
                            return transactionGroupApi.getTransactionGroups();
                        } else {
                            return userApi.getUserTransactionGroup().then(function (tg) {
                                return [tg];
                            });
                        }
                    }],
                    isComplianceAdmin: ["permissionService", function (permissionService) {
                        if (permissionService
                            .hasAllPermissions([{ AccessObject: "UsersAll", ActionType: "View" }])) {
                            return true;
                        } else
                            return false;
                    }],
                    lineOfBusinessCategories: ["lineOfBusinessCategoryApi", function (lineOfBusinessCategoryApi) {
                        return lineOfBusinessCategoryApi.getCategories();
                    }],
                }
            });
    }]);

    app.component("manageUsers",
        {
            templateUrl: "/App/Users/ManageUsers/template.html",
            controller: manageUsersController,
            bindings: {
                user: "<",
                users: "<",
                userRegistrations: "<",
                transactionGroups: "<",
                isComplianceAdmin: "<",
                lineOfBusinessCategories: "<",
            }
        });

    manageUsersController.$inject = ["_", "transactionGroupApi", "$state", "$mdDialog", "userRegistrationApi", "permissionService", "userApi", "agentApi", "$filter"];
    function manageUsersController(_, transactionGroupApi, $state, $mdDialog, userRegistrationApi, permissionService, userApi, agentApi, $filter) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    isLoading: true,
                },
                goToUser: goToUser,
                getState: getState,
                getAgents: getAgents,
                registeredArcAgents: [],
                openRegistrationModal: openRegistrationModal,
                disclosureSort: disclosureSort,
                permissionService: permissionService,
                openManageUsersModal: openManageUsersModal
            });

        function disclosureSort(user) {
            if (!user.DisclosureIds && user.Roles.includes('Agent'))
                return 0;
            else if (user.DisclosureIds && user.Roles.includes('Agent'))
                return 1;
            else
                return 2;
        };

        function getState(u, $event) {

            if (u.UserMemberId) {
                //$state.go('Home.ManageUsers.ConfigureUserAccount', { userMemberId: u.UserMemberId });
                $ctrl.openManageUsersModal(u.UserMemberId, $event);
            } else {
                $ctrl.openRegistrationModal(u, $event);
            }
        }

        this.$onInit = function () {
            $ctrl.selectedTransactionGroup = $ctrl.transactionGroups.length === 1 ? $ctrl.transactionGroups[0].Id : null;

            $ctrl.userAndAgentList = [];
            $ctrl.userList = [];
                     
            ng.forEach($ctrl.users,
                function (u) {                  
                    if (u.ArcAgentId)
                        $ctrl.registeredArcAgents.push(u.ArcAgentId);
                    if (!$ctrl.user.Roles.includes('ComplianceAdministrator') && u.Roles.includes('ComplianceAdministrator')) {
                        //Do not list Compliance Administrators if the current logged in user is not a Compliance Administrator
                    }
                    else {
                        var user = buildUserListModel(u);
                        var index = _.findIndex($ctrl.transactionGroups, function (row) { return row.Id === user.TransactionGroupId });
                        user.TransactionGroupName = index !== -1 ? $ctrl.transactionGroups[index].Name : null;
                        $ctrl.userList.push(user);
                    }
                });
          
            $ctrl.userList = $filter('orderBy')($ctrl.userList, ['TransactionGroupName', 'FirstName'], false),

            ng.forEach($ctrl.userRegistrations, function (u) {
                if (u.ArcAgentId)
                    $ctrl.registeredArcAgents.push(u.ArcAgentId);
                var user = buildUserListModel(u);
                var index = _.findIndex($ctrl.transactionGroups, function (row) { return row.Id === user.TransactionGroupId });
                if (index !== -1) {
                    user.TransactionGroupName = $ctrl.transactionGroups[index].Name;
                }
                $ctrl.userList.push(user);

            });

            function buildUserListModel(user) {             
                var u = user;
                var allowedLineOfBusinessCategories = [];
                ng.forEach(u.AllowedLineOfBusinessCategoryIds, function (catId) {
                    var index = _.findIndex($ctrl.lineOfBusinessCategories, function (row) { return row.Id === catId });
                    if (index !== -1) {
                        allowedLineOfBusinessCategories.push($ctrl.lineOfBusinessCategories[index].LineOfBusiness.Name + " - " + $ctrl.lineOfBusinessCategories[index].Name);
                    }
                });
               
                var model = {
                    FirstName: u.FirstName || (u.User ? u.User.FirstName : null),
                    MiddleName: u.MiddleName || (u.User ? u.User.MiddleName : null),
                    LastName: u.LastName || (u.User ? u.User.LastName : null),
                    TransactionGroupId: u.TransactionGroupId,
                    TransactionGroupName: u.TransactionGroupName,
                    IsActive: u.IsActive || false,
                    Roles: u.Roles,
                    DisclosureIds: u.DisclosureIds || null,
                    UserMemberId: u.ExpirationDate ? null : u.Id,
                    UserRegistrationId: u.ExpirationDate ? u.Id : null,
                    UserId: u.UserId || null,
                    ArcAgentId: u.ArcAgentId || null,
                    Completed: u.Completed,
                    ExpirationDate: u.ExpirationDate || null,
                    AllowedLineOfBusinessCategoryIds: u.AllowedLineOfBusinessCategoryIds,
                    AllowedLineOfBusinessCategories: $filter('orderBy')(allowedLineOfBusinessCategories, true).join("<br>"),
                    Email: u.EmailAddress || (u.User ? u.User.Email : null)
                };
              
                return model;
            }

            getAgents();

            $ctrl.UI.isLoading = false;
        };
      
        function goToUser(index) {
            var user = $ctrl.userList[index];
            $state.go(".ConfigureUserAccount", { userId: user.UserId });
        }

        function getAgents() {
            if ($ctrl.selectedTransactionGroup !== null) {
                $ctrl.userAndAgentList = _.filter($ctrl.userList,
                    function (u) {
                        return u.TransactionGroupId === $ctrl.selectedTransactionGroup;
                    });
                transactionGroupApi.get($ctrl.selectedTransactionGroup).then(function (tg) {
                    transactionGroupApi
                        .getTransactionGroupArcBusinessAgents($ctrl.selectedTransactionGroup, tg.BusinessId)
                        .then(function (agents) {
                            //console.log(agents)
                            var tg = _.find($ctrl.transactionGroups,
                                function (row) { return row.Id === $ctrl.selectedTransactionGroup });
                            var transactionGroupName = tg.Name;
                            ng.forEach(agents,
                                function (a) {
                                    if (!$ctrl.registeredArcAgents.includes(a.ArcAgentId)) {
                                        $ctrl.userAndAgentList.push({
                                            UnregisteredArcAgent: true,
                                            FirstName: a.Agent.Person.FirstName,
                                            LastName: a.Agent.Person.LastName,
                                            TransactionGroupId: $ctrl.selectedTransactionGroup,
                                            TransactionGroupName: transactionGroupName,
                                            IsActive: false,
                                            Roles: null,
                                            DisclosureIds: null,
                                            UserRegistrationId: null,
                                            UserId: null,
                                            ArcAgentId: a.ArcAgentId,
                                            Completed: null,
                                            ExpirationDate: null,
                                            Email: a.EmailAddress
                                        });
                                    }
                                });

                        });
                });

            } else
                $ctrl.userAndAgentList = ng.copy($ctrl.userList);
        }

        function openRegistrationModal(registration, $event) {

            var registrationModal = {
                templateUrl: "/App/Users/ManageUsers/Registration/template.html",
                parent: ng.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                controller: userRegistrationController,
                controllerAs: "$ctrl",
                resolve: {
                    registration: [
                        function () { return registration }],
                    transactionGroups: [function () { return $ctrl.transactionGroups }],
                    isComplianceAdmin: [function () { return $ctrl.isComplianceAdmin }],
                    lineOfBusinessCategories: [function () { return $ctrl.lineOfBusinessCategories }],
                }
            };

            $mdDialog.show(registrationModal);
        }

        function openManageUsersModal(userMemberId, $event) {

            userApi.getTransactionGroupUserMember(userMemberId).then(function (u) {
                agentApi.getAgentForUserId(u.User.Id).catch(ng.noop).then(function (a) {
                    var userModal = {
                        templateUrl: "/App/Dashboard/ConfigureAgentAccount/template.html",
                        parent: ng.element(document.body),
                        targetEvent: $event,
                        clickOutsideToClose: false,
                        controller: configureUserAccountController,
                        controllerAs: "$ctrl",
                        bindToController: true,
                        resolve: {
                            user: [function () { return u }],
                            agent: [function () { return a }],
                            lineOfBusinessCategories: [function () { return $ctrl.lineOfBusinessCategories }],
                        }
                    };

                    $mdDialog.show(userModal).then(function (response) {                     
                        if (response.user) {

                            var allowedLineOfBusinessCategories = [];
                            ng.forEach(u.AllowedLineOfBusinessCategoryIds, function (catId) {
                                var index = _.findIndex($ctrl.lineOfBusinessCategories, function (row) { return row.Id === catId });
                                if (index !== -1) {
                                    allowedLineOfBusinessCategories.push($ctrl.lineOfBusinessCategories[index].LineOfBusiness.Name + " - " + $ctrl.lineOfBusinessCategories[index].Name);
                                }
                            });

                            for (var i = 0; i < $ctrl.userAndAgentList.length; i++) {
                                if ($ctrl.userAndAgentList[i].UserId === response.user.UserId) {
                                   
                                    $ctrl.userAndAgentList[i].DisclosureIds = response.user.DisclosureIds;
                                    $ctrl.userAndAgentList[i].IsActive = response.user.IsActive;
                                    $ctrl.userAndAgentList[i].FirstName = response.user.User.FirstName;
                                    $ctrl.userAndAgentList[i].MiddleName = response.user.User.MiddleName;
                                    $ctrl.userAndAgentList[i].LastName = response.user.User.LastName;
                                    $ctrl.userAndAgentList[i].Email = response.user.User.Email;
                                    $ctrl.userAndAgentList[i].Roles = response.user.Roles;
                                    $ctrl.userAndAgentList[i].AllowedLineOfBusinessCategoryIds = response.user.AllowedLineOfBusinessCategoryIds;
                                    $ctrl.userAndAgentList[i].AllowedLineOfBusinessCategories = $filter('orderBy')(allowedLineOfBusinessCategories).join("<br>"),
                                    $ctrl.userAndAgentList[i].TransactionGroupId = response.user.TransactionGroupId;
                                    $ctrl.userAndAgentList[i].TransactionGroupName =
                                        _.find($ctrl.transactionGroups, function (g) {
                                            return g.Id === response.user.TransactionGroupId;
                                        }).Name;
                                }
                            }
                        }
                    });
                });
            });
        }
    };


    configureUserAccountController.$inject = ["$mdDialog", "permissionService", "$state", "disclosureApi", "agentApi", "transactionGroupApi", "_", "$q", "userDelegateApi", "userApi", "user", "agent"];

    function configureUserAccountController($mdDialog, permissionService, $state, disclosureApi, agentApi, transactionGroupApi, _, $q, userDelegateApi, userApi, user, agent) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    isSaving: false,
                    isClosing: false,
                    isLoading: true,
                    CurrentView: 0
                },
                user: user,
                agent: agent,
                permissionService: permissionService,
                description: description,
                navigateToBasicInfo: navigateToBasicInfo,
                navigateToDisclosure: navigateToDisclosure,
                navigateToDelegateConfig: navigateToDelegateConfig,
                navigateToOtherSettings: navigateToOtherSettings,
                close: close,
                save: save,
                onSave: onSave
            });
                
        this.$onInit = function () {
            var onSaveFunc = function () { };
            $ctrl.viewAsUserRoles = [];            
            userApi.getContextUserIds().then(function (userContext) {
                var getCurrentUserDelegate = userDelegateApi.getCurrentUserDelegate().catch(ng.noop);
                var getTransactionGroupUserMemberForUser = userApi.getTransactionGroupUserMemberForUser(userContext.ActingUserId);

                $q.all([
                    getCurrentUserDelegate, getTransactionGroupUserMemberForUser
                ]).then(function (data) {

                    var delegateUser = data[0];
                    var actingUser = data[1];

                    if (delegateUser) {
                        $ctrl.viewAsUserRoles = delegateUser.Roles;
                        $ctrl.UI.ShowDelegateConfig = false;
                        $ctrl.UI.ShowBasicInfo = false;
                        $ctrl.UI.CurrentView = 1;
                    } else {
                        $ctrl.viewAsUserRoles = actingUser.Roles;
                        $ctrl.UI.ShowDelegateConfig = true;
                        $ctrl.UI.ShowBasicInfo = true;
                    }

                    $ctrl.UI.isLoading = false;
                });
            });
        }

        function navigateToBasicInfo() {
            $ctrl.UI.CurrentView = 0;
        }

        function navigateToOtherSettings() {
            $ctrl.UI.CurrentView = 3;
        }

        function navigateToDisclosure() {
            if (!$ctrl.agent) return;
            //$ctrl.disclosures = [];
            //if ($ctrl.agent.DisclosureIds) {
            //    ng.forEach($ctrl.agent.DisclosureIds,
            //        function (disclosureId) {
            //            agentApi.getAgentDisclosure($ctrl.agent.Id, disclosureId).then(function (response) {
            //                $ctrl.disclosures.push(response);                            
            //        });
            //    });              
            //} 

            $ctrl.UI.CurrentView = 1;
        }

        function navigateToDelegateConfig() {
            $ctrl.UI.CurrentView = 2;
        }

        function description(view) {
            switch (view) {
                case 0: return "Basic Personal and Account Information";
                case 1: return "Manage Account Specific Documents and Disclosures";
                case 2: return "Manage Office Support And Delegates";
                case 3: return "Entity Specific User Settings";
                default: return "";
            }
        }

        function close() {
            $ctrl.UI.isClosing = true;

            return $mdDialog.hide({
                user: $ctrl.user,
            });
            //return $state.go("^", {}, { reload: true });
        }

        function onSave(func) {
            onSaveFunc = function () {
                $ctrl.UI.isSaving = true;

                return func().then(function () {
                    $ctrl.UI.isSaving = false;
                });
            };
        }

        function save() {
            onSaveFunc();
        }
    }

    userRegistrationController.$inject = ["userRegistrationApi", "$mdDialog", "$state", "registration", "transactionGroups", "isComplianceAdmin", "userApi", "prosperaSalesForceApi", "salesForceApi", "lineOfBusinessCategories"];
    function userRegistrationController(userRegistrationApi, $mdDialog, $state, registration, transactionGroups, isComplianceAdmin, userApi, prosperaSalesForceApi, salesForceApi, lineOfBusinessCategories) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {},
                roles: [{ Name: "Agent", Value: "Agent" }, { Name: "Reviewer", Value: "Reviewer" }, { Name: "Entity Administrator", Value: "EntityAdministrator" }, { Name: "Compliance Administrator", Value: "ComplianceAdministrator" }],
                close: close,
                send: send,
                searchEmailAddresses: searchEmailAddresses,
                transactionGroups: transactionGroups,
                registration: registration,
                isComplianceAdmin: isComplianceAdmin,
                deleteRegistration: deleteRegistration,
                lookupProsperaAccountNumber: lookupProsperaAccountNumber,
                removeExternalSfAgentRegistration: removeExternalSfAgentRegistration,
                lineOfBusinessCategories: lineOfBusinessCategories
            });

        this.$onInit = function() {          
            if ($ctrl.registration.UserRegistrationId) {
                ng.forEach($ctrl.roles,
                    function (r) {
                        if ($ctrl.registration.Roles.includes(r.Value))
                            r.Active = true;
                    });

                console.log($ctrl.registration)

                ng.forEach($ctrl.lineOfBusinessCategories,
                    function (lob) {
                        if ($ctrl.registration.AllowedLineOfBusinessCategoryIds.includes(lob.Id))
                            lob.Active = true;
                    });

                salesForceApi.getExternalSfAdvisorRegistration($ctrl.registration.UserRegistrationId).then(function (result) {
                    console.log(result);
                    $ctrl.prospera = {
                        Found: true,
                        AccountNumber: result.SfAccountNumber,
                        Name: result.SfAccountName,
                        AccountId: result.SfAccountId
                    };
                }).catch(function (error) {
                    $ctrl.prospera = {};
                }
                );
            }
            if ($ctrl.registration.UnregisteredArcAgent) {
                $ctrl.roles[0].Active = true;
            }
            if (!$ctrl.isComplianceAdmin) {
                $ctrl.registration.TransactionGroupId = $ctrl.transactionGroups[0].Id;
            }


        }        

        function lookupProsperaAccountNumber() {
            if (!$ctrl.prospera || !$ctrl.prospera.AccountNumber) return;

            $ctrl.UI.isLoading = true;

            prosperaSalesForceApi.lookupAdvisorSf($ctrl.prospera.AccountNumber).then(function (result) {
                console.log(result);

                if (result.records.length > 0) {
                    $ctrl.prospera.Found = true;
                    $ctrl.prospera.AccountNumber = result.records[0].AccountNumber;
                    $ctrl.prospera.AccountId = result.records[0].Id;
                    $ctrl.prospera.Name = result.records[0].Name;

                    if ($ctrl.registration.UserRegistrationId) {
                        var agentRegistrationRecord = {
                            UserRegistrationId: $ctrl.registration.UserRegistrationId,
                            SfAccountName: $ctrl.prospera.Name,
                            SfAccountId: $ctrl.prospera.AccountId,
                            SfAccountNumber: $ctrl.prospera.AccountNumber,
                            ExternalSfEntity: "Prospera"
                        }

                        salesForceApi.createExternalSfAdvisorRegistrationRecord(agentRegistrationRecord).then(function (result) {
                            $ctrl.prospera = {
                                Found: true,
                                AccountNumber: result.SfAccountNumber,
                                Name: result.SfAccountName,
                                AccountId: result.SfAccountId
                            };
                        });
                    }

                } else {

                    $ctrl.prospera.Found = false;
                    $ctrl.prospera.AccountId = "";
                    $ctrl.prospera.Name = "";
                }

                $ctrl.UI.isLoading = false;
                console.log($ctrl.prospera);
            });
        }

        function searchEmailAddresses(term) {
            return userApi.searchUserEmailAddresses(term)
                .then(function (result) {
                    if (result) {
                        $ctrl.emailExists = true;
                        return $ctrl.register.$setValidity("email", false);
                    } else {
                        $ctrl.emailExists = false;
                        return $ctrl.register.$setValidity("email", true);
                    }
                    //var results = [];
                    //ng.forEach(result,
                    //    function (row) {
                    //        row.Term = row.Person.FirstName + " " + row.Person.LastName;
                    //        if (!$ctrl.primaryAgent || (($ctrl.primaryAgent && $ctrl.primaryAgent.Id !== row.Id) && !_.find($ctrl.secondaryAgents, function (ag) { return ag.Id === row.Id; })))
                    //            results.push(row);
                    //    });
                    //return results;
                });
        }

        function deleteRegistration() {
            $ctrl.UI.isDeleting = true;
            userRegistrationApi.deleteUserRegistration($ctrl.registration.UserRegistrationId).then(function () {
                $ctrl.UI.isDeleting = false;
                close();

                salesForceApi.deleteExternalSfAdvisorRegistrationRecord($ctrl.registration.UserRegistrationId).then(
                    function () {
                        $ctrl.prospera = {};
                    }).catch(function (error) {
                        $ctrl.prospera = {};
                    }
                    );
            });
        }

        function removeExternalSfAgentRegistration() {

            if ($ctrl.registration.UserRegistrationId)
                salesForceApi.deleteExternalSfAdvisorRegistrationRecord($ctrl.registration.UserRegistrationId).then(function () {
                    $ctrl.prospera = {};
                }).catch(function (error) {
                    $ctrl.prospera = {};
                }
                );

            else $ctrl.prospera = {};
        }

        // check for at least one selected role
        $ctrl.requireOneRole = function () {
            return !$ctrl.roles.some(function (role) {
                return role.Active;
            });
        };

        $ctrl.requireOneLobCategory = function () {
            return !$ctrl.lineOfBusinessCategories.some(function (lob) {
                return lob.Active;
            });
        };

        function send() {
            if ($ctrl.registration.UserRegistrationId) {
                $ctrl.UI.IsSaving = true;
                return userRegistrationApi.resendUserRegistration($ctrl.registration.UserRegistrationId).then(function () {
                    $ctrl.UI.IsSaving = false;
                    close();
                });
            } else {
                $ctrl.registration.Roles = [];

                ng.forEach($ctrl.roles,
                    function (r) {
                        if (r.Active) {
                            $ctrl.registration.Roles.push(r.Value);
                        }
                    });

                var activeLobCatIds = _.filter($ctrl.lineOfBusinessCategories,
                    function (lob) {
                        return lob.Active;
                    });
              
                $ctrl.registration.AllowedLineOfBusinessCategoryIds = [];
                ng.forEach($ctrl.lineOfBusinessCategories,
                    function (lob) {
                        if (lob.Active) {
                            $ctrl.registration.AllowedLineOfBusinessCategoryIds.push(lob.Id);
                        }
                    });

                console.log($ctrl.registration);
                if (!$ctrl.emailExists &&
                    $ctrl.registration.FirstName &&
                    $ctrl.registration.LastName &&
                    $ctrl.registration.Email &&
                    $ctrl.registration.TransactionGroupId &&
                    $ctrl.registration.Roles.length &&
                    activeLobCatIds.length) {

                    $ctrl.error = false;
                    $ctrl.UI.IsSaving = true;
                    $ctrl.registration.EmailAddress = $ctrl.registration.Email;

                    var request = {
                        FirstName: $ctrl.registration.FirstName,
                        MiddleName: $ctrl.registration.MiddleName,
                        LastName: $ctrl.registration.LastName,
                        TransactionGroupId: $ctrl.registration.TransactionGroupId,
                        EmailAddress: $ctrl.registration.Email,
                        Roles: $ctrl.registration.Roles,
                        ArcAgentId: $ctrl.registration.ArcAgentId,
                        AllowedLineOfBusinessCategoryIds: $ctrl.registration.AllowedLineOfBusinessCategoryIds,
                    };


                    return userRegistrationApi.createUserRegistration(request)
                        .then(function (userRegistration) {

                            if ($ctrl.prospera !== null && $ctrl.prospera.Found !== null) {

                                if (userRegistration && $ctrl.prospera.Found) {

                                    var agentRegistrationRecord = {
                                        UserRegistrationId: userRegistration.Id,
                                        SfAccountName: $ctrl.prospera.Name,
                                        SfAccountId: $ctrl.prospera.AccountId,
                                        SfAccountNumber: $ctrl.prospera.AccountNumber,
                                        ExternalSfEntity: "Prospera"
                                    };

                                    salesForceApi.createExternalSfAdvisorRegistrationRecord(agentRegistrationRecord).then(function (result) {
                                        $ctrl.prospera = {
                                            Found: true,
                                            AccountNumber: result.SfAccountNumber,
                                            Name: result.SfAccountName,
                                            AccountId: result.SfAccountId
                                        };
                                    });
                                }
                            }

                            $ctrl.UI.IsSaving = false;

                        })
                        .catch(function (error) {
                            console.log(error);
                            $ctrl.error = true;
                        })
                        .finally(function () {
                            return close();
                        });
                } else {
                    console.log("error")
                    $ctrl.error = true;
                }

            }
        }

        function close() {
            $mdDialog.hide().then(function () {
                $state.go($state.current, {}, { reload: true });
            });
        }
    }
})(window.app, window.angular);